export default "__VITE_ASSET__DsxDA8KG__"